// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__W1s6o","label":"styles_label__1nRUx"};